var module = angular.module('components');
module.component('wgtIntegrationStatus', {
    templateUrl: 'components/dashboard/widgets/wgtIntegrationStatus/wgtIntegrationStatus.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        item: '<'
    },
    controller: ['DashboardApiService','$rootScope','$scope','$translate','$timeout',controller]
});


function controller(DashboardApiService,$rootScope, $scope,$translate, $timeout)  {
    var vm = this;
    var reqPromise = null;

    vm.widgetData = null;
    vm.isLoaded = false;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    function onInit() {
    }

    function onChanges(changes) {
        loadWidget();
    }

    function loadWidget() {

        DashboardApiService
            .getWidgetData(vm.item.name, vm.item.setting)
            .then(onNewData,onNewDataError);
    }

    function onNewData(response) {
        vm.widgetData = response.data;
        vm.isLoaded = true;
        vm.hasError = false;

        reqPromise = $timeout(loadWidget, 30000);
    }

    function onNewDataError(response) {
        vm.hasError = true;

        reqPromise = $timeout(loadWidget, 60000);
    }

    function onDestroy() {
        if (reqPromise != null) {
            $timeout.cancel(reqPromise);
        }
    }

}
